import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=c6da65fa&scoped=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=ts"
export * from "./MultipleChoice.vue?vue&type=script&lang=ts"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=c6da65fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6da65fa",
  null
  
)

export default component.exports